import {RouterModule, Routes} from '@angular/router';
import {RegistrierenComponent} from './registrieren/registrieren.component';
import {PocsagComponent} from './pocsag/pocsag.component';
import {UserComponent} from './user/user.component';
 import {FahrzeugeComponent} from './fahrzeuge/fahrzeuge.component';
import {StandortComponent} from './standort/standort.component';
 import {PocsagDetailComponent} from './pocsag/pocsag-detail.component';
import {MenuComponent} from './menu/menu.component';
import {ReleasenotesComponent} from './releasenotes/releasenotes.component';

const APP_ROUTES: Routes = [
    {path: '', component: MenuComponent},
    {path: 'menu', component: MenuComponent},
    {path: 'registrieren', component: RegistrierenComponent},
    {path: 'pocsag', component: PocsagComponent},
    {path: 'pocsag/:id', component: PocsagComponent},
    {path: 'pocsagdetail/:id', component: PocsagDetailComponent},
    {path: 'user', component: UserComponent},
    {path: 'fahrzeuge', component: FahrzeugeComponent},
    {path: 'fahrzeuge/:id', component: FahrzeugeComponent},
    {path: 'standort', component: StandortComponent},
    {path: 'releasenotes', component: ReleasenotesComponent},


];

export const routing = RouterModule.forRoot(APP_ROUTES, { useHash: true });
